import { render } from "./TopPage.vue?vue&type=template&id=067dda3a"
import script from "./TopPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TopPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "067dda3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('067dda3a', __exports__)) {
    api.reload('067dda3a', __exports__)
  }
  
  module.hot.accept("./TopPage.vue?vue&type=template&id=067dda3a", () => {
    api.rerender('067dda3a', render)
  })

}


export default __exports__